module.exports = __webpack_public_path__ + "static/PathsLogo-NewSpace-75b31d17d76b1c3a4cd46ef2671ec696.png";